// OrderWizard launcher module
// Handles opening the OrderWizard modal from various CTAs throughout the site

const OrderWizardLauncher = () => {
  const BUTTON_SELECTOR = '.open-wizard-button';
  let isInitialized = false;

  const openModal = () => {
    window.dispatchEvent(new CustomEvent('OpenOrderWizardModal'));
  };

  const handleButtonClick = () => {
    openModal();
  };

  const attachListeners = () => {
    if (isInitialized) return;

    document.addEventListener('click', event => {
      const button = event.target.closest(BUTTON_SELECTOR);
      if (button) {
        handleButtonClick();
      }
    });

    isInitialized = true;
  };

  const handleOrderWizardReady = () => {
    attachListeners();
  };

  const init = () => {
    if (isInitialized) return;

    // Check if OrderWizard is already ready
    if (window.OrderWizardReady === true) {
      attachListeners();
    } else {
      // Only register the event listener if not already ready
      // Use { once: true } to automatically remove the listener after first execution
      window.addEventListener('OrderWizardReady', handleOrderWizardReady, { once: true });
    }
  };

  return { init };
};

export default OrderWizardLauncher;
